import { ClassicEditor, ContextWatchdog, EditorWatchdog } from 'ckeditor5';

/**
 * @ckeditor/ckeditor5-react constructs editor.EditorWatchdog.
 * Newer ckeditor5 builds no longer attach that constructor to ClassicEditor.
 */
const editor = ClassicEditor as typeof ClassicEditor & {
  EditorWatchdog: typeof EditorWatchdog;
  ContextWatchdog: typeof ContextWatchdog;
};

if (typeof editor.EditorWatchdog !== 'function') {
  editor.EditorWatchdog = EditorWatchdog;
}
if (typeof editor.ContextWatchdog !== 'function') {
  editor.ContextWatchdog = ContextWatchdog;
}

export default editor;
